import * as styles from "./MenuContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Menu as BaseMenu } from "@base-ui/react/menu";

import { useMenuContext } from "./Menu.context";
import type { MenuContentProps } from "./Menu.types";
import { MenuArrow } from "./MenuArrow";
import { MenuPortal } from "./MenuPortal";
import { ARROW_SIZES } from "./constants";

const GAP = 4;

export function MenuContent({
  className,
  children,
  positionMethod,
  side,
  align,
  ...props
}: MenuContentProps): JSX.Element {
  const context = useMenuContext();
  const { size, variant, arrow } = context;

  const sideOffset = arrow ? ARROW_SIZES[size] : GAP;

  return (
    <MenuPortal>
      <BaseMenu.Positioner
        data-slot="menu-positioner"
        className={styles.positioner}
        side={side ?? context.side}
        align={align ?? context.align}
        sideOffset={sideOffset}
        positionMethod={positionMethod}
      >
        <BaseMenu.Popup
          data-slot="menu-popup"
          className={clsx(
            styles.popup,
            styles.popupVariant[variant],
            className,
          )}
          {...props}
        >
          {arrow && <MenuArrow />}
          {children}
        </BaseMenu.Popup>
      </BaseMenu.Positioner>
    </MenuPortal>
  );
}
